module.exports = __webpack_public_path__ + "static/visbug-8447cce8c1aaafa3b8d23c38bdb7b332.png";